import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNbaComponent } from './simple-icons-nba.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNbaComponent ],
    exports:      [ SimpleIconsNbaComponent ],
    bootstrap:    []
})
export class SimpleIconsNbaModule {}
